import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

export const ContactGetAssociationsInputsSchema = z.object({
  'contact-id': z
    .string()
    .describe('ID of the contact to get associations for'),
})

export const ContactGetAssociationsCommandSchema =
  WorkflowNodeBaseSchema.extend({
    service: z.object({
      name: z.literal('skedyul/conversations'),
      cmd: z.literal('contact.getAssociations'),
      options: z.record(z.string(), z.unknown()).optional(),
    }),
    inputs: ContactGetAssociationsInputsSchema,
  })

export type ContactGetAssociationsCommand = z.infer<
  typeof ContactGetAssociationsCommandSchema
>
